export const SET_IDENTITY_DOCS = 'SET_IDENTITY_DOCS';

export function setIdentityDocs(payload) {
  return {
    type: SET_IDENTITY_DOCS,
    payload
  };
}
